module.exports = __webpack_public_path__ + "static/media/digmentha-race.74f18b55.svg";